(function (window) {
  'use strict';

  window.CONFIG = {
    SessionName: 'SIMULADOR_CCMA',
    EndPointPath : location.protocol + '//testing.clasificados.com.co/ccma/Matriculainscripcionvirtual/',
    AppExt: '.wsa',
    UrlExt: '.html',
    CodigoCamara: '21',
    Camara: 'Medellín',
    TextoCostos: `Los costos de los años siguientes, están basados en las tarifas del presente año, por lo anterior debes
        tener en cuenta que estas tarifas aumentan basados en el incremento del salario mínimo mensual legal
        vigente de cada año.
        <br>
        Los costos que arroja el simulador no reemplazan las liquidaciones que realiza cada entidad cuando presentas
        el trámite. Recuerda que son valores aproximados y cada entidad puede realizar modificaciones en las
        mismas. Es tu responsabilidad verificar la veracidad y vigencia de los valores.`
  };
})(window);
